<template>
  <div v-if="stepsStory && shown" class="flex flex-col">
    <div class="flex">
      <p class="font-semibold uppercase text-brand-orange text-[16px] md:text-[24px] lg:text-[32px]">harmonogram</p>
    </div>
    <div class="flex md:flex-row flex-col justify-center">
      <div class="flex flex-col md:w-1/2 md:pr-[10%] mb-[72px] md:mb-0">
        <P class="font-extrabold text-[28px] md:text-[40px] lg:text-[56px] mb-3">Co se bude dít?</P>
        <p class="md:text-[18px] lg:text-[18px] text-[16px]" style="line-height: 28px">
          Shopcamp se sice koná až 17. září, být jeho součástí ale můžete už mnohem dříve.
        </p>
        <p class="mt-5 mb-12 md:text-[18px] lg:text-[18px] text-[16px]" style="line-height: 28px">Část programu Shopcampu je tvořena barcampem, do kterého může kdokoliv přihlásit svou přednášku nebo workshop. O tom, které z nich se dostanou do konečného programu, rozhodují účastníci s platnou vstupenkou.</p>
          <CalendarDropdown></CalendarDropdown>
      </div>
      <div class="md:w-1/2">
        <div>
          <Step ref="target" :targetIsVisible="stepVisible1" :timeType="stepTypeTime1" :title="stepTimes[0].title"
                :description="stepTimes[0].description"
                :date="formatDateTime(stepsStory.prihlasovani, { withTime: stepsStory.prihlasovani_withTime })">
            <a href="/prednaska/registrace"
               class="mt-0 md:mt-5 w-full justify-left md:justify-start md:w-auto mb-10 font-medium rounded-md  md:text-button text-[12px]  inline-flex items-center"
               :class="{ 'hover:opacity-80 transition-all group duration-200 text-black': happeningRegistrationOpened, 'cursor-not-allowed pointer-events-none text-brand-gray-500': !happeningRegistrationOpened }">
              <svg class="mr-2 md:block hidden"
                   :class="{ 'transition-all duration-200 ease-in-out text-black transform group-hover:scale-110': happeningRegistrationOpened, 'text-brand-gray-500': !happeningRegistrationOpened }"
                   width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M11.9999 2C9.52354 2 7.49994 4.0236 7.49994 6.5C7.49994 8.9764 9.52354 11 11.9999 11C14.4763 11 16.4999 8.9764 16.4999 6.5C16.4999 4.0236 14.4763 2 11.9999 2ZM20.9316 2.50098C20.9267 2.50125 20.9218 2.50158 20.9169 2.50195C19.8535 2.54643 18.9999 3.4356 18.9999 4.5V9.39648L15.7587 12.3076C15.6209 12.4315 15.4433 12.5 15.2578 12.5H13.7499C13.6041 12.4999 13.4614 12.5424 13.3392 12.6222C13.2171 12.7019 13.1209 12.8156 13.0624 12.9492L11.9999 15.3779L11.0361 13.1768C10.9639 13.0118 10.8348 12.8784 10.6724 12.8007C10.5099 12.7231 10.325 12.7065 10.1513 12.7539C7.1827 13.5662 4.99994 16.2819 4.99994 19.5V20.5H2.24994C2.15056 20.4986 2.05188 20.517 1.95966 20.554C1.86743 20.5911 1.78349 20.6461 1.71271 20.7159C1.64194 20.7857 1.58573 20.8688 1.54737 20.9605C1.50901 21.0522 1.48926 21.1506 1.48926 21.25C1.48926 21.3494 1.50901 21.4478 1.54737 21.5395C1.58573 21.6312 1.64194 21.7143 1.71271 21.7841C1.78349 21.8539 1.86743 21.9089 1.95966 21.946C2.05188 21.983 2.15056 22.0014 2.24994 22H21.7499C21.8493 22.0014 21.948 21.983 22.0402 21.946C22.1324 21.9089 22.2164 21.8539 22.2872 21.7841C22.3579 21.7143 22.4141 21.6312 22.4525 21.5395C22.4909 21.4478 22.5106 21.3494 22.5106 21.25C22.5106 21.1506 22.4909 21.0522 22.4525 20.9605C22.4141 20.8688 22.3579 20.7857 22.2872 20.7159C22.2164 20.6461 22.1324 20.5911 22.0402 20.554C21.948 20.517 21.8493 20.4986 21.7499 20.5H18.9999V16.7891C18.9999 16.6099 19.0627 16.4384 19.1786 16.3027C19.179 16.3024 19.1793 16.3021 19.1796 16.3018L22.8193 12.0352C23.295 11.4776 23.5281 10.7524 23.4677 10.0225L22.9931 4.33398C22.9056 3.28269 21.9842 2.47786 20.9316 2.50098ZM11.9999 3.5C13.6657 3.5 14.9999 4.83426 14.9999 6.5C14.9999 8.16574 13.6657 9.5 11.9999 9.5C10.3342 9.5 8.99994 8.16574 8.99994 6.5C8.99994 4.83426 10.3342 3.5 11.9999 3.5ZM20.9716 4.00293C21.2801 3.99947 21.4747 4.17785 21.498 4.45801L21.9726 10.1465C22.0002 10.4795 21.8939 10.8081 21.6777 11.0615L18.038 15.3291C17.6905 15.7362 17.4999 16.2546 17.4999 16.7891V20.5H6.49994V19.5C6.49994 17.1885 7.95281 15.2836 9.96381 14.4678L11.3124 17.5508C11.3708 17.6846 11.4669 17.7984 11.5891 17.8784C11.7112 17.9583 11.854 18.0009 11.9999 18.0009C12.1459 18.0009 12.2887 17.9583 12.4108 17.8784C12.5329 17.7984 12.6291 17.6846 12.6874 17.5508L14.2402 14H15.2578C15.8122 14 16.3476 13.795 16.7607 13.4238C16.761 13.4238 16.7613 13.4238 16.7617 13.4238L20.2509 10.2881C20.3292 10.2178 20.3918 10.1318 20.4347 10.0358C20.4776 9.9397 20.4999 9.83568 20.4999 9.73047V4.5C20.4999 4.22747 20.7007 4.01873 20.9716 4.00293Z"
                  fill="currentColor"/>
              </svg>
              <svg class="mr-2 block md:hidden"
                   :class="{ 'transition-all duration-200 ease-in-out text-black transform group-hover:scale-110': happeningRegistrationOpened, 'text-brand-gray-500': !happeningRegistrationOpened }"
                   xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M7.09304 1.32227C5.62894 1.32227 4.43254 2.51866 4.43254 3.98276C4.43254 5.44685 5.62894 6.64325 7.09304 6.64325C8.55713 6.64325 9.75353 5.44685 9.75353 3.98276C9.75353 2.51866 8.55713 1.32227 7.09304 1.32227ZM12.3736 1.61845C12.3707 1.61862 12.3678 1.61881 12.3649 1.61903C11.7362 1.64533 11.2316 2.17102 11.2316 2.80032V5.69522L9.31531 7.41634C9.2338 7.48957 9.12882 7.53008 9.01912 7.53008H8.12767C8.04143 7.53003 7.95705 7.55513 7.88486 7.6023C7.81267 7.64947 7.7558 7.71667 7.72121 7.79567L7.09304 9.23157L6.52318 7.93019C6.4805 7.83268 6.40418 7.75377 6.30814 7.70787C6.21211 7.66198 6.10277 7.65215 6.00009 7.68019C4.24498 8.16045 2.95449 9.76602 2.95449 11.6686V12.2598H1.32864C1.26988 12.259 1.21154 12.2699 1.15702 12.2918C1.10249 12.3137 1.05286 12.3462 1.01102 12.3875C0.969173 12.4287 0.935945 12.4779 0.913265 12.5321C0.890585 12.5863 0.878906 12.6445 0.878906 12.7033C0.878906 12.762 0.890585 12.8202 0.913265 12.8744C0.935945 12.9286 0.969173 12.9778 1.01102 13.019C1.05286 13.0603 1.10249 13.0928 1.15702 13.1147C1.21154 13.1366 1.26988 13.1475 1.32864 13.1467H12.8574C12.9162 13.1475 12.9745 13.1366 13.0291 13.1147C13.0836 13.0928 13.1332 13.0603 13.1751 13.019C13.2169 12.9778 13.2501 12.9286 13.2728 12.8744C13.2955 12.8202 13.3072 12.762 13.3072 12.7033C13.3072 12.6445 13.2955 12.5863 13.2728 12.5321C13.2501 12.4779 13.2169 12.4287 13.1751 12.3875C13.1332 12.3462 13.0836 12.3137 13.0291 12.2918C12.9745 12.2699 12.9162 12.259 12.8574 12.2598H11.2316V10.0659C11.2316 9.95996 11.2687 9.85857 11.3372 9.77833C11.3374 9.77814 11.3376 9.77795 11.3378 9.77776L13.4896 7.25525C13.7709 6.9256 13.9087 6.49687 13.873 6.06531L13.5924 2.70216C13.5407 2.08062 12.9959 1.60479 12.3736 1.61845ZM7.09304 2.2091C8.07785 2.2091 8.8667 2.99794 8.8667 3.98276C8.8667 4.96758 8.07785 5.75642 7.09304 5.75642C6.10822 5.75642 5.31937 4.96758 5.31937 3.98276C5.31937 2.99794 6.10822 2.2091 7.09304 2.2091ZM12.3973 2.50644C12.5796 2.50439 12.6947 2.60986 12.7085 2.77549L12.9891 6.13863C13.0054 6.33554 12.9426 6.52979 12.8147 6.67962L10.6629 9.2027C10.4574 9.44341 10.3447 9.7499 10.3447 10.0659V12.2598H3.84132V11.6686C3.84132 10.302 4.70029 9.17581 5.88923 8.69347L6.68657 10.5162C6.72108 10.5953 6.77792 10.6626 6.85011 10.7099C6.92231 10.7572 7.00674 10.7823 7.09304 10.7823C7.17933 10.7823 7.26376 10.7572 7.33596 10.7099C7.40816 10.6626 7.46499 10.5953 7.4995 10.5162L8.41751 8.41691H9.01912C9.34693 8.41691 9.66343 8.29569 9.90768 8.07627C9.90788 8.07627 9.90807 8.07627 9.90826 8.07627L11.9712 6.22235C12.0175 6.1808 12.0545 6.12997 12.0799 6.07318C12.1052 6.01638 12.1184 5.95488 12.1184 5.89268V2.80032C12.1184 2.63919 12.2371 2.51578 12.3973 2.50644Z"  fill="currentColor"/>
              </svg>

              Chci přednášet
            </a>
          </Step>

          <Step :timeType="stepTypeTime2" :targetIsVisible="stepVisible2" :title="stepTimes[1].title"
                :description="stepTimes[1].description"
                :date="formatDateTime(stepsStory.registrace, { withTime: stepsStory.registrace_withTime })">
            <a v-show="!userLoggedIn" :href="route('frontend.registration')"
               class="mt-0 md:mt-5 mb-10 w-full md:w-auto justify-left md:justify-start font-medium rounded-md  md:text-button text-[12px] inline-flex items-center"
               :class="{ 'text-black hover:opacity-80 transition-all duration-200 group underline': registrationPageOpened, 'cursor-not-allowed pointer-events-none text-brand-gray-500': !registrationPageOpened }">
              Chci přijít
              <svg class="md:block hidden ml-2 group-hover:translate-x-2 transform transition-all duration-200" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
                  fill="currentColor"/>
              </svg>
              <svg class="md:hidden block ml-2 group-hover:translate-x-2 transform transition-all duration-200" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M10.1911 4.27734C10.1028 4.27737 10.0166 4.30371 9.94339 4.35302C9.87021 4.40233 9.81339 4.47235 9.78022 4.55412C9.74706 4.6359 9.73904 4.72571 9.7572 4.81207C9.77536 4.89842 9.81887 4.9774 9.88217 5.03889L12.0813 7.23806H1.03176C0.973004 7.23723 0.914667 7.24809 0.860141 7.27C0.805615 7.29191 0.755988 7.32444 0.714143 7.3657C0.672298 7.40695 0.63907 7.45612 0.61639 7.51033C0.59371 7.56454 0.582031 7.62272 0.582031 7.68148C0.582031 7.74024 0.59371 7.79842 0.61639 7.85263C0.63907 7.90684 0.672298 7.956 0.714143 7.99726C0.755988 8.03852 0.805615 8.07105 0.860141 8.09296C0.914667 8.11487 0.973004 8.12573 1.03176 8.12489H12.0813L9.88217 10.3241C9.83961 10.3649 9.80564 10.4139 9.78224 10.468C9.75883 10.5222 9.74647 10.5805 9.74587 10.6394C9.74527 10.6984 9.75644 10.757 9.77874 10.8116C9.80104 10.8662 9.83401 10.9158 9.87573 10.9575C9.91745 10.9992 9.96706 11.0322 10.0217 11.0545C10.0763 11.0768 10.1348 11.088 10.1938 11.0874C10.2528 11.0868 10.3111 11.0744 10.3652 11.051C10.4194 11.0276 10.4683 10.9936 10.5092 10.9511L13.4653 7.99499C13.5484 7.91183 13.5951 7.79906 13.5951 7.68148C13.5951 7.5639 13.5484 7.45113 13.4653 7.36797L10.5092 4.41187C10.4679 4.36931 10.4184 4.33547 10.3638 4.31236C10.3091 4.28925 10.2504 4.27735 10.1911 4.27734Z" fill="currentColor"/>
              </svg>
            </a>
            <div v-show="userLoggedIn"
                 class="border-brand-gray-500 cursor-not-allowed mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md text-brand-gray-500 md:text-button text-[12px] inline-flex items-center py-[18px] px-[68px]">
              Již jste přihlášen/a
            </div>
          </Step>

          <Step :timeType="stepTypeTime3" :targetIsVisible="stepVisible3" :title="stepTimes[2].title"
                :description="stepTimes[2].description"
                :date="formatDateTime(stepsStory.hlasovani, { withTime: stepsStory.hlasovani_withTime })">

            <a :href="route('frontend.happening-list')"
               class="mt-0 md:mt-5 mb-10 w-full md:w-auto justify-left md:justify-start font-medium rounded-md  md:text-button text-[12px] inline-flex items-center"
               :class="{ 'text-black hover:opacity-80 transition-all duration-200 group underline': happeningVotingOpened, 'cursor-not-allowed pointer-events-none text-brand-gray-500': !happeningVotingOpened }">
              Chci hlasovat
              <svg class="md:block hidden ml-2 group-hover:translate-x-2 transform transition-all duration-200" width="24" height="24"
                   viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                  d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
                  fill="currentColor"/>
              </svg>
              <svg class="md:hidden block ml-2 group-hover:translate-x-2 transform transition-all duration-200" xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 15 15" fill="none">
                <path d="M10.1911 4.27734C10.1028 4.27737 10.0166 4.30371 9.94339 4.35302C9.87021 4.40233 9.81339 4.47235 9.78022 4.55412C9.74706 4.6359 9.73904 4.72571 9.7572 4.81207C9.77536 4.89842 9.81887 4.9774 9.88217 5.03889L12.0813 7.23806H1.03176C0.973004 7.23723 0.914667 7.24809 0.860141 7.27C0.805615 7.29191 0.755988 7.32444 0.714143 7.3657C0.672298 7.40695 0.63907 7.45612 0.61639 7.51033C0.59371 7.56454 0.582031 7.62272 0.582031 7.68148C0.582031 7.74024 0.59371 7.79842 0.61639 7.85263C0.63907 7.90684 0.672298 7.956 0.714143 7.99726C0.755988 8.03852 0.805615 8.07105 0.860141 8.09296C0.914667 8.11487 0.973004 8.12573 1.03176 8.12489H12.0813L9.88217 10.3241C9.83961 10.3649 9.80564 10.4139 9.78224 10.468C9.75883 10.5222 9.74647 10.5805 9.74587 10.6394C9.74527 10.6984 9.75644 10.757 9.77874 10.8116C9.80104 10.8662 9.83401 10.9158 9.87573 10.9575C9.91745 10.9992 9.96706 11.0322 10.0217 11.0545C10.0763 11.0768 10.1348 11.088 10.1938 11.0874C10.2528 11.0868 10.3111 11.0744 10.3652 11.051C10.4194 11.0276 10.4683 10.9936 10.5092 10.9511L13.4653 7.99499C13.5484 7.91183 13.5951 7.79906 13.5951 7.68148C13.5951 7.5639 13.5484 7.45113 13.4653 7.36797L10.5092 4.41187C10.4679 4.36931 10.4184 4.33547 10.3638 4.31236C10.3091 4.28925 10.2504 4.27735 10.1911 4.27734Z" fill="currentColor"/>
              </svg>
            </a>

            <!-- <a
        :href="route('frontend.happening-list')"
        class="mt-0 md:mt-5 mb-10 border-2 w-full md:w-auto justify-center md:justify-start font-medium rounded-md  text-button inline-flex items-center py-[18px] px-[68px]"
        :class="{'border-brand-blue text-brand-blue hover:opacity-80 transition-all duration-200 group': true}"
      >
        Výsledky hlasování
        <svg
          class="ml-2 group-hover:translate-x-2 transform transition-all duration-200"
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M17.2421 5.99219C17.0929 5.99222 16.947 6.03679 16.8232 6.12019C16.6994 6.20358 16.6033 6.32202 16.5472 6.46033C16.4911 6.59865 16.4776 6.75056 16.5083 6.89662C16.539 7.04269 16.6126 7.17627 16.7197 7.28027L20.4394 11H1.74994C1.65056 10.9986 1.55188 11.017 1.45966 11.054C1.36743 11.0911 1.28349 11.1461 1.21271 11.2159C1.14194 11.2857 1.08573 11.3688 1.04737 11.4605C1.00901 11.5522 0.989258 11.6506 0.989258 11.75C0.989258 11.8494 1.00901 11.9478 1.04737 12.0395C1.08573 12.1312 1.14194 12.2143 1.21271 12.2841C1.28349 12.3539 1.36743 12.4089 1.45966 12.446C1.55188 12.483 1.65056 12.5014 1.74994 12.5H20.4394L16.7197 16.2197C16.6477 16.2888 16.5902 16.3716 16.5506 16.4632C16.511 16.5548 16.4901 16.6534 16.4891 16.7532C16.4881 16.8529 16.507 16.9519 16.5447 17.0443C16.5824 17.1367 16.6382 17.2206 16.7088 17.2912C16.7793 17.3617 16.8633 17.4175 16.9556 17.4552C17.048 17.4929 17.147 17.5118 17.2468 17.5108C17.3466 17.5098 17.4451 17.4889 17.5367 17.4493C17.6283 17.4097 17.7111 17.3523 17.7802 17.2803L22.7802 12.2803C22.9208 12.1396 22.9998 11.9489 22.9998 11.75C22.9998 11.5511 22.9208 11.3604 22.7802 11.2197L17.7802 6.21973C17.7103 6.14773 17.6267 6.0905 17.5342 6.05142C17.4418 6.01233 17.3425 5.99219 17.2421 5.99219Z"
            fill="currentColor"
          />
        </svg>
      </a> -->
          </Step>

          <Step :targetIsVisible="stepVisible4" :timeType="stepTypeTime4" :title="stepTimes[3].title"
                :description="stepTimes[3].description"
                :date="formatDateTime(stepsStory.program, { withTime: stepsStory.program_withTime })">

          </Step>

          <Step :targetIsVisible="stepVisible5" :timeType="stepTypeTime5" :title="stepTimes[4].title"
                :description="stepTimes[4].description"
                :date="formatDateTime(stepsStory.showtime, { withTime: stepsStory.showtime_withTime })"
                :hasLine="false">

          </Step>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>

import Step from "./Step.vue";
import {ref, watch, computed} from 'vue';
import {useIntersectionObserver, promiseTimeout} from '@vueuse/core';
import {isWithinInterval, isBefore} from 'date-fns';
import {useStoryBlokStore} from "../../stores/storyblok";
import CalendarDropdown from "../CalendarDropdown.vue";
import {format} from "date-fns";
import {cs} from 'date-fns/locale';

const props = defineProps({
  happeningRegistrationOpened: {
    type: Boolean,
    default: false
  },
  registrationPageOpened: {
    type: Boolean,
    default: false
  },
  happeningVotingOpened: {
    type: Boolean,
    default: false
  },
  userLoggedIn: {
    type: Boolean,
    default: false
  },
  shopcampDate: {
    type: String,
    default: ''
  }
})
const storyBlockStore = useStoryBlokStore();

const target = ref(null)

const stepVisible1 = ref(false)
const stepVisible2 = ref(false)
const stepVisible3 = ref(false)
const stepVisible4 = ref(false)
const stepVisible5 = ref(false)

// e.g. 7. září
const formattedDate = computed(() => {
  return format(new Date(props.shopcampDate), 'd. MMMM', {locale: cs});
})

const shown = computed(() => {
  return storyBlockStore.steps.shown;
});

const stepsStory = computed(() => {
  return storyBlockStore.steps;
});
const nextStepIndex = computed(() => {
  const now = new Date();
  // Find the first step whose date is in the future
  return stepTimes.value.findIndex(step => isBefore(now, step.date)) + 1 || null;
});
const stepTimes = computed(() => {
  return [
    {
      step: 1,
      date: new Date(stepsStory.value.prihlasovani),
      title: stepsStory.value.prihlasovani_title,
      description: stepsStory.value.prihlasovani_description,
    },
    {
      step: 2,
      date: new Date(stepsStory.value.registrace),
      title: stepsStory.value.registrace_title,
      description: stepsStory.value.registrace_description,
    },
    {
      step: 3,
      date: new Date(stepsStory.value.hlasovani),
      title: stepsStory.value.hlasovani_title,
      description: stepsStory.value.hlasovani_description,
    },
    {
      step: 4,
      date: new Date(stepsStory.value.program),
      title: stepsStory.value.program_title,
      description: stepsStory.value.program_description,
    },
    {
      step: 5,
      date: new Date(stepsStory.value.showtime),
      title: stepsStory.value.showtime_title,
      description: stepsStory.value.showtime_description,
    },
  ];
});

const stepTypeTime1 = computed(() => {
  return getTimeTypeForStep(1);
})
const stepTypeTime2 = computed(() => {
  return getTimeTypeForStep(2);
})
const stepTypeTime3 = computed(() => {
  return getTimeTypeForStep(3);
})
const stepTypeTime4 = computed(() => {
  return getTimeTypeForStep(4);
})
const stepTypeTime5 = computed(() => {
  return getTimeTypeForStep(5);
})

const {stop} = useIntersectionObserver(
  target,
  ([{isIntersecting}], observerElement) => {
    stepVisible1.value = isIntersecting
  },
)

watch(stepVisible1, async (val, oldVal) => {
  if (val) {
    //stop observing
    stop()

    await promiseTimeout(750);
    stepVisible2.value = true;

    await promiseTimeout(750);
    stepVisible3.value = true;

    await promiseTimeout(750);
    stepVisible4.value = true;

    await promiseTimeout(750);
    stepVisible5.value = true;
  }
})

function getTimeTypeForStep(step) {
  const now = new Date();
  if (isBefore(stepTimes.value[step - 1].date, now)) {
    return 'past';
  }
  if (nextStepIndex.value === step) {
    return 'next';
  }
  return 'future';
}

function formatDateTime(storyBlockDate, {withTime = false} = {}) {
  const date = new Date(storyBlockDate);

  if (withTime) {
    const options = {year: 'numeric', month: 'numeric', day: 'numeric', hour: 'numeric', minute: 'numeric'};
    return date.toLocaleDateString('cs-CZ', options);
  } else {
    const options = {year: 'numeric', month: 'numeric', day: 'numeric'};
    return date.toLocaleDateString('cs-CZ', options);
  }
}
</script>
